import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinkUI from '@material-ui/core/Link';
import DPP from "./DPP.pdf"; // adjust path as needed







const useStyles = makeStyles({
  root: {
    marginTop: 30,
    width: '100%',
    padding: '3%',
    margin: 'auto',
    fontSize: '16',
    minWidth: 600,
  },
  p: {
    color: '#333333',
    paddingTop: 0,
    marginTop: 12,
    fontSize: 16
  },
  h4: {
    paddingLeft: 0,
    textAlign: 'left',
    color: '#009688',
    //color: '#6a737b',
    marginTop: 0,
    marginBottom: 20,
    marginLeft: 0
  }

});



function Contact() {

  const classes = useStyles();



  return (
   <div>
  <Grid
    container
    spacing={2}
    style={{
      marginTop: 70,
      marginBottom: -20,
      padding: '5%',
      paddingTop: 0,
      backgroundColor: '#E6EBE9',
    }}
  >
    {/* Header */}
    <Grid
      item
      xs={12}
      style={{
        minWidth: 200,
        borderLeft: '0.03em solid grey',
        paddingLeft: '3%',
        paddingTop: 0,
      }}
    >
      <Typography variant="h3" className={classes.h4}>
        The Aztec Diamond
      </Typography>
      <Typography variant="h4" className={classes.h4}>
        An analytic journey through random tilings
      </Typography>
    </Grid>

    {/* Main content */}
    <Grid
      item
      xs={12}
      style={{
        minWidth: 200,
        paddingLeft: '3%',
        paddingTop: 0,
      }}
    >
      <Typography
        variant="h6"
        style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
      >
        Description
      </Typography>

      <Typography className={classes.p}>
        Random tilings of planar domains have many remarkable features, with deep
        connections to statistical mechanics, combinatorics, integrable systems,
        random growth models, representation theory, and random matrix theory.
        When the domains are large, limit shapes appear and the fluctuations are
        expected to be described by universal laws. At the same time, in many
        situations they can be described as determinantal point processes,
        providing a framework for asymptotic studies. This is a very active and
        competitive area of mathematical research that has witnessed dramatic
        progress in the past two decades. There are many important open problems
        that need to be answered, many structures that need to be better
        understood, and very likely other interesting phenomena yet to be
        discovered.
      </Typography>

      <Typography className={classes.p}>
        The purpose of the course is to give an introduction to random tilings,
        with special focus on analytical methods and techniques. The running
        example will be that of domino tilings of the Aztec diamond. The course
        will deal with both classical results in the field as well as some of the
        most recent developments. Highlights of the course include: Schur
        processes and their extensions, orthogonal polynomials, Wiener–Hopf
        factorizations and doubly periodic weighted tilings, asymptotic analysis
        using steepest descent techniques, Arctic circles and limit shapes,
        limiting Gibbs measures, and Gaussian free field fluctuations.
      </Typography>

      <Typography className={classes.p}>
        After completion of the course, students are expected to have gained an
        understanding of the relevant research questions, acquired important
        techniques for addressing them, and be prepared to study some of the open
        problems in the field.
      </Typography>

      <Typography
        variant="h6"
        style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
      >
        Prerequisites
      </Typography>

      <Typography className={classes.p}>
        A good knowledge of probability and analysis is recommended. Some of the
        technical aspects of the course will require familiarity with complex
        analysis.
      </Typography>

      <Typography
        variant="h6"
        style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
      >
        Overview of the lectures
      </Typography>

      <Typography className={classes.p}>
        January 15 (Thu), 14:00–17:15 
        <br />
        <strong>Lecture 1:</strong>
        <br />
        Introduction; discrete determinantal point processes
        <br />
        <a href={DPP} download="DPP.pdf" target="_blank" rel="noopener noreferrer">
                Lecture notes on DPP
        </a>
        <br />
        <br />
        January 22 (Thu), 14:00–17:15  <br />
        <strong>Lecture 2:</strong>
        <br />
        Schur processes
        <br />
        <br />
        January 27 (Tue), 09:30–12:45  <br />
        <strong>Lecture 3:</strong>
        <br />
        Asymptotic study of the uniform Aztec diamond
        <br />
        <br />
        February 3 (Tue), 09:30–12:45 <br />
        <strong>Lecture 4:</strong>
        <br />
        Shuffling algorithm and dynamics
        <br />
        <br />
        <strong>Lecture 5:</strong>
        <br />
        Doubly periodic tilings
        <br />
        <br />
        <strong>Lecture 6:</strong>
        <br />
        Height fluctuations and the Gaussian free field
        <br />
        <br />
        <strong>Lecture 7:</strong>
        <br />
        Orthogonal polynomials, Painlevé transcendents, and lozenge tilings of the
        hexagon
      </Typography>

      <Typography
        variant="h6"
        style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}
      >
        Literature
      </Typography>

      <Typography className={classes.p}>
        {/* Add references here */}
      </Typography>
    </Grid>
  </Grid>
</div>

  );
}


export default Contact